import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import classNames from 'classnames';
import noop from 'lodash/noop';
import { shallowEqual } from 'app-source/utils/shallowEqual';
import { Radio } from './Radio';

const styles = (theme) => ({
  // custom classes
  hover: {
    '&:hover': {
      backgroundColor: '#EEEEEE',
    },
  },
  revealedChoice: {
    color: '#000000',
  },
  selectedChoice: {
    backgroundColor: '#CCCCCC',
    color: theme.palette.text.secondary,
    '& $label': {
      color: 'inherit',
    },
  },
  correct: {
    backgroundColor: '#fdf00e',
    color: theme.palette.text.secondary,
    '& $label': {
      color: 'inherit',
    },
  },

  // overwrites
  root: {
    borderRadius: 5,
    margin: [[theme.spacing.unit / 2, 0]],
  },
  disabled: {},
  label: {},
});

class TriviaChoice extends Component {
  static propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired, // eslint-disable-line max-len,react/no-unused-prop-types
    handleChoiceSelect: PropTypes.func,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    selectedValue: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
    isCorrect: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
  };

  static defaultProps = {
    checked: false,
    disabled: false,
    handleChoiceSelect: noop,
    isCorrect: null,
    selectedValue: null,
  };

  shouldComponentUpdate(nextProps, nextState) {
    return !shallowEqual(this, nextProps, nextState, {
      propsSelectOptions: { omit: ['classes'] },
    });
  }

  handleOnChange = (e) => {
    this.props.handleChoiceSelect(e.target.value);
  };

  render() {
    const {
      checked,
      classes: { hover, correct, revealedChoice, selectedChoice, ...classes },
      disabled,
      isCorrect,
      label,
      value,
    } = this.props;

    return (
      <FormControlLabel
        className={classNames({
          [correct]: typeof isCorrect === 'boolean' && isCorrect,
          [hover]: !disabled,
          [revealedChoice]: disabled && typeof isCorrect === 'boolean',
          [selectedChoice]: checked,
        })}
        classes={classes}
        disabled={disabled}
        value={value}
        margin="none"
        control={<Radio checked={checked} isCorrect={isCorrect} onChange={this.handleOnChange} />}
        label={label}
      />
    );
  }
}

export const TriviaChoiceComponent = withStyles(styles)(TriviaChoice);
